module.exports = __webpack_public_path__ + "static/empty-state-value-props-obvious-dont-7b9129fc61f53d0fac624fbd73496823.png";